// eslint-disable-next-line import/prefer-default-export
export const constants = {
  addressLinesCharLength: '240',
  otherAddressDetailsCharLength: '60',
  nameCharLength: '200',
  companyNameCharLength: '360',
};
